<script lang="ts" setup="">
import type { DropdownField } from '@hubspot/api-client/lib/codegen/marketing/forms'
import { faChevronDown } from '@fortawesome/pro-light-svg-icons'
import {
  Label,
  SelectContent,
  SelectItem,
  SelectItemIndicator,
  SelectItemText,
  SelectPortal,
  SelectRoot,
  SelectTrigger,
  SelectValue,
  SelectViewport,
} from 'reka-ui'

const { field } = defineProps<{
  field: DropdownField
}>()

const options = computed(() => [...field.options].sort((a, b) => a.displayOrder - b.displayOrder))
</script>

<template>
  <div class="flex flex-col gap-2xs">
    <Label :class="inputVariants.label()" :for="field.name">
      <span>
        {{ field.label }}
        <span v-if="field.required" class="text-red-500">*</span>
      </span>
    </Label>
    <SelectRoot
      :id="field.name"
      v-slot="{ open }"
      :hidden="field.hidden"
      :name="field.name"
      :default-value="field.defaultValues"
      :required="field.required"
    >
      <SelectTrigger
        class="w-full flex items-center gap-s pr-s data-[state=open]:border-blurple-300"
        :class="inputVariants.base({ isSearch: false, error: false })"
      >
        <SelectValue :placeholder="field.placeholder" />

        <Icon
          :icon="faChevronDown"
          class="transition-all duration-300 ml-auto"
          :class="{ 'rotate-180': open }"
        />
      </SelectTrigger>

      <SelectPortal>
        <SelectContent
          side="bottom"
          position="popper"
          class="bg-white rounded-lg border border-blurple-300 mt-2 transition-colors shadow-sm overflow-hidden w-[--reka-select-trigger-width]"
        >
          <SelectViewport>
            <SelectItem
              v-for="option in options"
              :key="option.value"
              :value="option.value"
              class="px-s py-xs hover:bg-blurple-50 transition-colors"
            >
              <SelectItemText>
                {{ option.label }}
              </SelectItemText>
              <SelectItemIndicator />
            </SelectItem>
          </SelectViewport>
        </SelectContent>
      </SelectPortal>
    </SelectRoot>
  </div>
</template>
